import { useState } from "react";
import { deleteCustomRegistrationField } from "../../api/customRegistrationFields";
import { Alert, ConfirmDialog } from "../../ui";
import "./styles.scss";

type DeleteCustomFieldDialogProps = {
  fieldId: string;
  fieldName: string;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

const DeleteCustomFieldDialog = (props: DeleteCustomFieldDialogProps) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleDelete = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      await deleteCustomRegistrationField(props.fieldId);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message || "An error occurred while deleting the field");
      // Keeps the dialog open
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={props.isOpen}
      onClose={(confirmed) => (confirmed ? props.onClose(true) : props.onClose())}
      onConfirm={handleDelete}
      loading={loading}
      title="Delete Custom Field"
      confirmLabel="Delete"
      message={
        <div className="delete-custom-field-dialog">
          {errorMessage && <Alert tone="danger">{errorMessage}</Alert>}
          <p>
            Are you sure you want to delete the custom field <strong>"{props.fieldName}"</strong>?
          </p>
          <p className="warning-text">
            This action cannot be undone. All data collected through this field will also be deleted.
          </p>
        </div>
      }
    />
  );
};

export default DeleteCustomFieldDialog;
